<template>
    <custom-container-main>
        <div class="row">
            <div class="col-lg-8">
                <div class="block-content">
                    <slot></slot>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="block-content">
                    <budget :budget-data="budgetData">
                        <slot name="replaceBudgetLines"></slot>
                    </budget>
                </div>
                <slot name="columnExtraData"></slot>
            </div>
        </div>
    </custom-container-main>
</template>

<script>
    import CustomContainerMain from "./CustomContainerMain";
    import Budget from "./Budget";
    export default {
        components: {
            CustomContainerMain,
            Budget
        },
        props: {
            budgetData: {
                type: Object
            }
        },
        watch: {
            budgetData(newVal) {
                this.budgetDataChanged();
            }
        },
        methods: {
            budgetDataChanged() {
                let varietySelected = null;
                let varietyPieSelected = null;
                if (this.budgetData) {
                    varietySelected = this.budgetData.variety;
                    varietyPieSelected = this.budgetData.varietyPie;
                }
                this.$store.commit('custom/setVarietySelected', varietySelected);
                this.$store.commit('custom/setVarietyPieSelected', varietyPieSelected);
            }
        },
        created() {
            this.budgetDataChanged();
        },
        name: "CustomContainerFull"
    }
</script>

<style scoped>
    .block-content {
        text-align: center;
    }
</style>
